import {
  GetKEKReinsurerAssociates,
  GetKEKReinsurerAssociatesVariables,
} from "_graphql/kek/queries/__generated__/GetKEKReinsurerAssociates";
import {
  GetKavaPremiumMemberLimit,
  GetKavaPremiumMemberLimitVariables,
} from "_graphql/visal/queries/__generated__/GetKavaPremiumMemberLimit";
import {
  GetKavaPremiumMemberLimits,
  GetKavaPremiumMemberLimitsVariables,
} from "_graphql/visal/queries/__generated__/GetKavaPremiumMemberLimits";
import {
  GetReinsurerParticipantPayment,
  GetReinsurerParticipantPaymentVariables,
} from "_graphql/queries/__generated__/GetReinsurerParticipantPayment";
import {
  GetReinsurerParticipantPayments,
  GetReinsurerParticipantPaymentsVariables,
} from "_graphql/queries/__generated__/GetReinsurerParticipantPayments";
import {
  GetReinsurerRep,
  GetReinsurerRepVariables,
} from "_graphql/queries/__generated__/GetReinsurerRep";
import {
  GetReinsurersAvailableToParticipateOnOffer,
  GetReinsurersAvailableToParticipateOnOfferVariables,
} from "_graphql/kek/queries/__generated__/GetReinsurersAvailableToParticipateOnOffer";
import {
  KEKReinsurer,
  KEKReinsurerVariables,
} from "_graphql/kek/queries/__generated__/KEKReinsurer";
import {
  Reinsurer,
  ReinsurerVariables,
} from "_graphql/visal/queries/__generated__/Reinsurer";
import {
  getKEKReInsurer,
  getKEKReInsurers,
  getKEKReinsurerAssociates,
} from "_graphql/kek/queries/reinsurers.kek";
import {
  getKavaPremiumMemberLimit,
  getKavaPremiumMemberLimits,
  getReInsurer,
  getReInsurerRep,
  getReInsurers,
  getReinsurerAssociates,
  getReinsurerOfferPayment,
  getReinsurerOfferPayments,
  getReinsurerReps,
} from "_graphql/visal/queries/re-insurers";

import { GetReinsurerReps } from "_graphql/queries/__generated__/GetReinsurerReps";
import { KEKReinsurers } from "_graphql/kek/queries/__generated__/KEKReinsurers";
import { Reinsurers } from "_graphql/visal/queries/__generated__/Reinsurers";
import { getReinsurersAvailableToParticipateOnOffer } from "_graphql/kek/queries/offers.kek";
import { useQuery } from "@apollo/client";
import {
  GetReinsurerAssociates,
  GetReinsurerAssociatesVariables,
} from "_graphql/visal/queries/__generated__/GetReinsurerAssociates";

export const useReInsurers = (variables?: any) => {
  const { page, pageSize, search } = variables || {
    page: 1,
    pageSize: 10,
    search: "",
  };
  const start = (parseInt(page) - 1) * pageSize;
  const end = start + pageSize;
  const { data, ...rest } = useQuery<Reinsurers>(getReInsurers, {
    variables: undefined,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  const items = data?.rows
    ?.filter((el) => {
      return (
        el?.re_company_name?.toLowerCase().includes(search.toLowerCase()) ||
        el?.re_company_email?.toLowerCase().includes(search.toLowerCase()) ||
        el?.re_abbrv?.toLowerCase().includes(search.toLowerCase()) ||
        el?.re_company_website?.toLowerCase().includes(search.toLowerCase())
      );
    })
    .slice(start, end);
  return {
    reInsurers: items || [],
    count: data?.count || 0,
    ...rest,
  };
};

export const useKEKReInsurers = (variables?: any) => {
  const { page, pageSize, search } = variables || {
    page: 1,
    pageSize: 10,
    search: "",
  };
  const start = (parseInt(page) - 1) * pageSize;
  const end = start + pageSize;
  const { data, ...rest } = useQuery<KEKReinsurers>(getKEKReInsurers, {
    variables: undefined,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  const items = data?.rows
    ?.filter((el) => {
      return (
        el?.re_company_name?.toLowerCase().includes(search.toLowerCase()) ||
        el?.re_company_email?.toLowerCase().includes(search.toLowerCase()) ||
        el?.re_abbrv?.toLowerCase().includes(search.toLowerCase()) ||
        el?.re_company_website?.toLowerCase().includes(search.toLowerCase())
      );
    })
    .slice(start, end);
  return {
    reInsurers: items || [],
    count: data?.count || 0,
    ...rest,
  };
};

export const useReInsurer = (id: string) => {
  const { data, ...rest } = useQuery<Reinsurer, ReinsurerVariables>(
    getReInsurer,
    {
      variables: {
        reinsurerId: id ?? "",
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
    }
  );
  return {
    reInsurer: data?.reinsurer,
    ...rest,
  };
};

export const useKEKReInsurer = (id: string) => {
  const { data, ...rest } = useQuery<KEKReinsurer, KEKReinsurerVariables>(
    getKEKReInsurer,
    {
      variables: {
        reinsurerId: id ?? "",
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
    }
  );
  return {
    reInsurer: data?.reinsurer,
    ...rest,
  };
};
export const useReInsurerReps = () => {
  const { data, ...rest } = useQuery<GetReinsurerReps>(getReinsurerReps, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  return {
    associates: data?.getReinsurerReps || [],
    ...rest,
  };
};

export const useAvailableReInsurerReps = (
  variables: GetReinsurersAvailableToParticipateOnOfferVariables
) => {
  const { data, ...rest } = useQuery<
    GetReinsurersAvailableToParticipateOnOffer,
    GetReinsurersAvailableToParticipateOnOfferVariables
  >(getReinsurersAvailableToParticipateOnOffer, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    associates: data?.getReinsurersAvailableToParticipateOnOffer || [],
    ...rest,
  };
};

export const useReInsurerRep = (variables?: GetReinsurerRepVariables) => {
  const { data, ...rest } = useQuery<GetReinsurerRep, GetReinsurerRepVariables>(
    getReInsurerRep,
    {
      notifyOnNetworkStatusChange: true,
      variables,
      fetchPolicy: "network-only",
    }
  );
  return {
    associate: data?.getReinsurerRep,
    ...rest,
  };
};

export const useReInsurerAssociates = (
  variables: GetReinsurerAssociatesVariables
) => {
  const { data, ...rest } = useQuery<
    GetReinsurerAssociates,
    GetReinsurerAssociatesVariables
  >(getReinsurerAssociates, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    associates: data?.getReinsurerAssociates || [],
    count: data?.count || 0,
    ...rest,
  };
};

export const useKEKReInsurerAssociates = (
  variables: GetKEKReinsurerAssociatesVariables
) => {
  const { data, ...rest } = useQuery<
    GetKEKReinsurerAssociates,
    GetKEKReinsurerAssociatesVariables
  >(getKEKReinsurerAssociates, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    associates: data?.getReinsurerAssociates || [],
    count: data?.count || 0,
    ...rest,
  };
};

export const useReinsurerKavaPremiumLimits = (
  variables: GetKavaPremiumMemberLimitsVariables
) => {
  const { data, ...rest } = useQuery<
    GetKavaPremiumMemberLimits,
    GetKavaPremiumMemberLimitsVariables
  >(getKavaPremiumMemberLimits, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    limits: data?.rows || [],
    count: data?.count || 0,
    ...rest,
  };
};

export const useReinsurerKavaPremiumLimit = (
  variables: GetKavaPremiumMemberLimitVariables
) => {
  const { data, ...rest } = useQuery<
    GetKavaPremiumMemberLimit,
    GetKavaPremiumMemberLimitVariables
  >(getKavaPremiumMemberLimit, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    limit: data?.getKavaPremiumMemberLimit,
    ...rest,
  };
};

export const useReInsurerOfferPayments = (
  variables: GetReinsurerParticipantPaymentsVariables
) => {
  const { data, ...rest } = useQuery<
    GetReinsurerParticipantPayments,
    GetReinsurerParticipantPaymentsVariables
  >(getReinsurerOfferPayments, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    payments: data?.getReinsurerParticipantPayments || [],
    ...rest,
  };
};
export const useReInsurerOfferPayment = (
  variables: GetReinsurerParticipantPaymentVariables
) => {
  const { data, ...rest } = useQuery<
    GetReinsurerParticipantPayment,
    GetReinsurerParticipantPaymentVariables
  >(getReinsurerOfferPayment, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables,
  });
  return {
    payment: data?.getReinsurerParticipantPayment,
    ...rest,
  };
};
